
import { defineComponent } from "vue";
import FooterInfo from "./footer-info.vue";

export default defineComponent({
  render() {
    return (
      <div class="app-footer">
        <FooterInfo />
        <div class="app-footer-bottom__nav">
          <a class="app-footer-bottom__tab">线路检测</a>
          <a class="app-footer-bottom__tab">关于我们</a>
          <a class="app-footer-bottom__tab">游戏规则</a>
          <a class="app-footer-bottom__tab">帮助中心</a>
          <a class="app-footer-bottom__tab">联系我们</a>
        </div>
        <div class="app-footer-bottom__copyright">
          Copyright © {new Date().getFullYear()} B Sports Group All{" "}
        </div>
      </div>
    );
  },
});
